/**
 * c_boost-ai-recommend.js
 * 1. Boost Commerce Recommendation API で商品を取得
 * 2. 各商品の /products/{handle}?view=card-only を並列fetchして、
 *    テーマの c_product-item スニペットで描画されたカードHTMLを抽出
 * 3. スライダー領域に並べる
 */
(() => {
  const API_ENDPOINT = 'https://services.mybcapps.com/discovery/recommend';

  const fetchCardHtml = async (handle) => {
    try {
      const res = await fetch('/products/' + encodeURIComponent(handle) + '?view=card-only', {
        credentials: 'same-origin',
      });
      if (!res.ok) return null;
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const card = doc.querySelector('[data-product-card-root]');
      return card ? card.outerHTML : null;
    } catch (e) {
      console.warn('[c_boost-ai-recommend] card fetch failed for', handle, e);
      return null;
    }
  };

  const pickHandle = (p) => {
    if (!p) return null;
    if (p.handle) return p.handle;
    if (p.url) {
      const m = p.url.match(/\/products\/([^?#/]+)/);
      if (m) return m[1];
    }
    return null;
  };

  const init = async (section) => {
    if (section.dataset.__initialized === 'true') return;
    section.dataset.__initialized = 'true';

    const widgetId = section.dataset.widgetId;
    const type = section.dataset.recommendationType || 'trending-products';
    const limit = parseInt(section.dataset.limit, 10) || 8;
    const shop = section.dataset.shop;
    const locale = section.dataset.locale || 'ja';
    const list = section.querySelector('[data-recommend-list]');

    if (!widgetId || !shop || !list) {
      console.warn('[c_boost-ai-recommend] missing widget_id / shop / list container');
      return;
    }

    let products;
    try {
      const res = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shop: shop,
          wid: widgetId,
          recommendationType: type,
          limit: limit,
          locale: locale,
        }),
      });
      if (!res.ok) throw new Error('status ' + res.status);
      const data = await res.json();
      products = (data && (data.products || data.items)) || [];
    } catch (e) {
      console.warn('[c_boost-ai-recommend] recommend API failed:', e);
      section.classList.add('is-error');
      return;
    }

    if (products.length === 0) {
      section.classList.add('is-empty');
      return;
    }

    const handles = products.map(pickHandle).filter(Boolean);
    const cards = await Promise.all(handles.map(fetchCardHtml));
    const validCards = cards.filter(Boolean);

    if (validCards.length === 0) {
      section.classList.add('is-empty');
      return;
    }

    list.innerHTML = validCards.join('');
    section.classList.add('is-loaded');

    // カード挿入後、LEEEPレビュー星の再スキャンをトリガー
    if (window.LeeepReviewScoreMarker && typeof window.LeeepReviewScoreMarker.scan === 'function') {
      try { window.LeeepReviewScoreMarker.scan(); } catch (e) { /* noop */ }
    }
  };

  const bootstrap = () => {
    document.querySelectorAll('.c_boost-ai-recommend').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
